import React, { useEffect, useState } from 'react';
import { LoadingRingIcon } from '@sharefiledev/flow-web';
import { Component } from '../../../../common/componentUtils';
import { SignatureSave } from '../../SignaturePad/constants';
import { SaveSignatureEvent } from '../../SignaturePad/SaveSignatureEvent';
import {
	SignatureAnnotationImage,
	SignatureAnnotationImageOverlayer,
} from './SignatureAnnotation.styled';

interface SignatureAnnotationProps {
	component: Component;
	width: number;
	height: number;
}

const SignatureAnnotation = ({ component, width, height }: SignatureAnnotationProps) => {
	const [imageSrc, setImageSrc] = useState('');
	const [saveState, setSaveState] = useState(SignatureSave.NOT_STARTED);

	useEffect(() => {
		if (component.signatureImage) {
			setImageSrc(component.signatureImage);
			setSaveState(SignatureSave.COMPLETED);
		}

		const listener = data => {
			if (data.detail) {
				const { id, message } = data.detail;
				if (id === component.id) {
					if (message === SignatureSave.STARTED) {
						setSaveState(SignatureSave.STARTED);
					}
				}
			}
		};

		SaveSignatureEvent.registerHandler(listener);

		return () => {
			SaveSignatureEvent.unRegisterHandler(listener);
		};
	}, [imageSrc, component.id, component.signatureImage, component.signatureText]);

	return imageSrc && saveState !== SignatureSave.STARTED ? (
		<>
			<SignatureAnnotationImageOverlayer />
			<SignatureAnnotationImage
				data-testid="signature-annotation-image"
				crossOrigin="anonymous"
				src={imageSrc}
				width={width}
				height={height}
			/>
		</>
	) : (
		<div data-testid="signature-annotation">
			{saveState === SignatureSave.STARTED && <LoadingRingIcon size={18} />}
		</div>
	);
};

export default SignatureAnnotation;
